import { render } from "./StatsTypeFilter.vue?vue&type=template&id=4c1a0d1c"
import script from "./StatsTypeFilter.vue?vue&type=script&lang=js"
export * from "./StatsTypeFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__